<template>

	<!-- Active Users Card -->
	<a-card :bordered="false" class="dashboard-bar-chart">
		<div class="card-header">
			<h6 class="card-title">生产个体数</h6>
			<div class="card-comparison">
				<template v-if="loading">加载中...</template>
				<template v-else-if="comparisonPercentage > 0">比上月<span class="text-success">+{{ comparisonPercentage }}%</span></template>
				<template v-else-if="comparisonPercentage < 0">比上月<span class="text-danger">{{ comparisonPercentage }}%</span></template>
				<template v-else>比上月<span class="text-neutral">0%</span></template>
			</div>
		</div>
		<div v-if="loading" class="chart-loading">
			<a-spin tip="加载中..." />
		</div>
		<div v-else class="chart-container">
			<chart-bar :data="barChartData"></chart-bar>
		</div>
	</a-card>
	<!-- Active Users Card -->

</template>

<script>

	// Bar chart for "Active Users" card.
	import ChartBar from '../Charts/ChartBar' ;

	export default ({
		components: {
			ChartBar,
		},
		data() {
			return {
				loading: true,
				comparisonPercentage: 0,
				// Data for bar chart.
				barChartData: {
					labels: [],
					datasets: [{
						label: '生产个体数',
						backgroundColor: '#2563EB',
						borderWidth: 0,
						borderSkipped: false,
						borderRadius: 4,
						data: [],
						maxBarThickness: 20,
					}],
				},
			}
		},
		async mounted() {
			await this.loadData();
		},
		methods: {
			async loadData() {
				try {
					const res = await this.$api.get_production_individual_stats();
					if (res && res.code === 200 && res.data) {
						const { monthly_data, comparison_percentage } = res.data;
						// 提取月份标签（取月份部分，如 "2026-03" -> "3月"）
						const labels = monthly_data.map(item => {
							const monthNum = parseInt(item.month.split('-')[1]);
							return `${monthNum}月`;
						});
						const data = monthly_data.map(item => item.count);
						this.barChartData = {
							labels,
							datasets: [{
								label: '生产个体数',
								backgroundColor: '#2563EB',
								borderWidth: 0,
								borderSkipped: false,
								borderRadius: 4,
								data,
								maxBarThickness: 20,
							}],
						};
						this.comparisonPercentage = comparison_percentage;
					}
				} catch (e) {
					console.error('[CardBarChart] 加载生产个体数数据失败', e);
				} finally {
					this.loading = false;
				}
			}
		}
	})

</script>

<style lang="scss" scoped>
.dashboard-bar-chart {
	border-radius: 16px;
	border: 1px solid #E5E7EB;
	box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.1) 0px 1px 2px -1px;
	background: #FFFFFF;
	height: 100%;
	display: flex;
	flex-direction: column;

	.card-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 16px;
		flex-shrink: 0;
	}

	.card-title {
		font-size: 16px;
		font-weight: 600;
		color: #111827;
		margin: 0;
		font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
	}

	.card-comparison {
		font-size: 13px;
		color: #6B7280;
		font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;

		.text-success {
			color: #10B981;
			font-weight: 500;
			margin-left: 4px;
		}

		.text-danger {
			color: #EF4444;
			font-weight: 500;
			margin-left: 4px;
		}

		.text-neutral {
			color: #6B7280;
			margin-left: 4px;
		}
	}

	.chart-loading {
		height: 300px;
		display: flex;
		align-items: center;
		justify-content: center;
		flex: 1;
	}

	.chart-container {
		height: 300px;
		flex: 1;
		position: relative;
	}

	::v-deep .ant-card-body {
		padding: 24px;
		display: flex;
		flex-direction: column;
		flex: 1;
	}
}
</style>
